import React from 'react'
import { WidgetProps } from '@rjsf/utils'
import { CirclePicker } from 'react-color'

export const ColorPaletteWidget: React.FC<WidgetProps> = ({ value, onChange }) => {
  return (
    <span style={{ width: 'calc(80% - 26px)' }}>
      <CirclePicker
        color={value || ''}
        onChangeComplete={({ hex }) => {
          if (hex === value) {
            onChange('')
            return
          }

          onChange(hex)
        }}
      />
    </span>
  )
}
